import React from 'react'
import {AVAILABLE_OR_NOT, RESERVATION_TYPE} from '../../../CodeMaster'
import {LotterySetting} from '../../facilities/FacilityForReservation'
import moment from 'moment'
import {ReserveFacilityModel} from '../ReserveFacilityModel'
import {calculateReservationType} from '../reservationTypeCalculator'
import {Nullable} from '../../../app/TypeHelpers'

interface Props {
    targetDate: string
    currentDateTime: moment.Moment
    lotteryAvailability: AVAILABLE_OR_NOT
    lotterySetting: LotterySetting
    reservationModel: ReserveFacilityModel
}


const RRFFReservationTypeView: React.FC<Props> = props => {
    const {targetDate, currentDateTime, lotteryAvailability, lotterySetting, reservationModel} = props
    const reservationType: Nullable<RESERVATION_TYPE> =
        calculateReservationType(moment(targetDate), currentDateTime, lotteryAvailability, lotterySetting)

    reservationModel.withReserveType(
        reservationType ? reservationType.value : null
    )

    return <>{
        reservationType ? reservationType.label : '-'
    }</>
}

RRFFReservationTypeView.displayName = 'RRFFReservationTypeView'
export default RRFFReservationTypeView
